const one={
	title: '`housing` - це ремесло',
	img:[
		'bi/cbf6e81d34dabf9c21277dc9e48g--tsvety-i-floristika-tsvetochnyj-gorshok.jpg',
		'bi/8529-1487603.jpg',
		'bi/07.jpg',
		'bi/955d2f975523a5150c87db74ddqi--tsvety-i-floristika-tsvetochnyj-gorshok.jpg',
	],
	text: 'Для нас `HOUSING` - це більше, ніж просто робота. Це наша\
		улюблена справа, наша мрія, до реалізації якої ми щиро прагнули\
		і результати якої наразі Ви можете побачити та оцінити.\
		З кожним днем ми хочемо дарувати Вам приємні емоції та\
		наповнювати оселі затишком і теплом. Асортимент нашої Компанії\
		дозволяє забезпечити гідний вибір навіть вкрай вибагливим покупцям,\
		догодити людині, яка шукає щось цікаве та нетривіальне, аби\
		урізноманітнити простір навколо себе чи лише трішки оновити\
		інтер’єр, додавши йому яскравого акценту. Ми завжди намагаємося\
		прислухатися до кожного покупця, розуміти його потреби і в якомога\
		коротший термін надавати необхідні товари за доступними цінами. '
};

export default one;